import styled from "styled-components";
import { cssVariables } from ".";

export const H1 = styled.h1`
  font-size: 7.2rem;
  letter-spacing: -1px;
  line-height: 1.25;
  font-weight: normal;
`;

export const H2 = styled.h2`
  font-weight: 400;
  font-size: 4.8rem;
  letter-spacing: -1px;
  line-height: 4.8rem;
`;

export const H3 = styled.h3`
  font-weight: 400;
  font-size: 3.6rem;
  letter-spacing: 0;
  line-height: 5rem;
`;

export const H4 = styled.h4`
  font-weight: normal;
  letter-spacing: 0;
  font-size: 2.4rem;
`;

export const H5 = styled.h5`
  font-size: 2rem;
  letter-spacing: 0;
  line-height: 3.4rem;
  font-weight: normal;
`;

export const Body = styled.p`
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1.5em; /* em not rem to scale with size */
`;

export const Label2 = styled.label`
  font-size: 1.4rem;
  line-height: 2.4rem;
`;

export const ErrorMessage = styled.p`
  color: ${cssVariables.colors.eyNotificationRed};
  font-weight: normal;
  font-size: 1.4rem;
`;

export const Blockquote = styled.blockquote`
  border-left: 0.5rem solid ${cssVariables.colors.primary1};
  font-size: 2rem;
  font-weight: 300;
  padding-left: 2rem;
  margin: 4rem 0;
  line-height: 3.2rem;
`;
